export default __webpack_public_path__ + "static/andrewdallas-75abb46a1645b3ff165b0130c379e7d5.png";